module.exports = __webpack_public_path__ + "img/jyj_wj_welcom_1_1.2b5da147.png";